const FILES_DOMAIN = 'files'

export default FILES_DOMAIN
